import { useContext, useState } from 'react'
import { Card, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap'
import AdminPicker from '../../../components/AdminPicker/AdminPicker'
import useCallApi from '../../../hooks/useCallApi'
import Advertiser from '../../../templates/Advertiser/Advertiser'
import Loading from '../../../templates/UI/Loading/Loading'
import ReportTable from '../../../templates/ReportTable/ReportTable'
import { useAuth, useProtectedPage } from '../../../context/AuthContext'
import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import AdvertiserRatePitch from '../../../components/AdvertiserRatePitchContent/AdvertiserRatePitchContent'
import queryString from 'query-string'
import { Button } from 'reactstrap'
import { SystemMessageContext } from '../../../context/SystemMessageContext'
import DateRangeFilter from '../../../pages/Reports/Filters/DateRangeFilter/DateRangeFilter'
import useDateRangeFilter from '../../../hooks/useDateRangeFilter'
import Dollars from '../../../templates/Dollars/Dollars'

const RatePitchSummaryContent = ({ }) => {
    const { showSystemMessage } = useContext(SystemMessageContext)
    const { initStartDate, initEndDate, selectedStartDate, selectedEndDate, quickDate, handleChangeStart, handleChangeEnd, handleQuickDate } = useDateRangeFilter()
    document.title = 'Rate Pitches Report'

    const auth = useAuth()

    const location = useLocation()
    let urlParams = queryString.parse(location.search)

    const [showModal, setShowModal] = useState(false)
    const [workingId, setWorkingId] = useState(false)


    const { data, dataLoaded, refetch } = useCallApi(`advertisers/ratePitchSummary?startDate=${selectedStartDate}&endDate=${selectedEndDate}`, 'GET', {}, [selectedStartDate, selectedEndDate])

    const getReportOutput = () => {
        let columns = [
            {
                Header: 'Admin ID',
                accessor: 'adminId',
            },
            {
                Header: 'Admin',
                accessor: 'adminName',
            },
            {
                Header: 'Selected Time Period',
                Cell: ({ cell: { value, row } }) => {
                    return (
                        <OverlayTrigger placement="top" overlay={<Tooltip id="default-rate-tooltip">Completed / Total (percentage)</Tooltip>} >
                            <span>{row.original.recent.completedCount} / {row.original.recent.totalCount} ({row.original.recent.percentage}%)</span>
                        </OverlayTrigger>
                    )

                }
            },
            {
                Header: 'All Time',
                Cell: ({ cell: { value, row } }) => {
                    return (
                        <OverlayTrigger placement="top" overlay={<Tooltip id="default-rate-tooltip">Completed / Total (percentage)</Tooltip>} >
                            <span>{row.original.allTime.completedCount} / {row.original.allTime.totalCount} ({row.original.allTime.percentage}%)</span>
                        </OverlayTrigger>
                    )
                }
            },
            {
                Header: 'Life Time Margin Increase',
                accessor: 'marginIncrease',
                Cell: ({ cell: { value, row } }) => {
                    return (
                        <Dollars value={value ? value : 0} />
                    )
                }
            },
            {
                Header: 'Detailed Report',
                Cell: ({ cell: { value, row } }) => {
                    return <Link to={`/advertisers/ratePitchReport?adminId=${row.original.adminId}`}>View Report</Link>
                },
            },

        ]

        return (
            <>
                <ReportTable data={data.summary} columns={columns} />
            </>
        )
    }

    const openModal = (e, id) => {
        e.preventDefault();
        setShowModal(true);
    }

    const closeModal = () => {
        setShowModal(false);
        refetch();
    }
    return (
        <Card>
            <Card.Header className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                    <h1 className="mb-h1-dark mr-2">Rate Pitch Summary</h1>
                    <DateRangeFilter quickDate={quickDate} selectedStartDate={selectedStartDate} selectedEndDate={selectedEndDate} handleChangeStart={handleChangeStart} handleChangeEnd={handleChangeEnd} handleQuickDate={handleQuickDate} />
                </div>
            </Card.Header>
            {dataLoaded ? data.summary.length === 0 ? <div className="p-3">No rate pitches found.</div> : getReportOutput() : <Loading />}
        </Card>
    )
}
export default RatePitchSummaryContent